import React from 'react';
import PropTypes from 'prop-types';

import { translate } from 'services/i18nService';

import styles from './GoldMembership.css';


const GoldMembershipItem = (props) => {
  const {
    actions,
    amount,
    currency,
    membership,
    months,
    price,
  } = props;


  const translationParams = {
    0: months,
    1: currency,
    2: amount,
  };

  let displayMembershipPeriod = undefined;
  const membershipPeriod = months !== 1;
  if (membershipPeriod) {
    displayMembershipPeriod = translate(
      'gold.upgrade.price.total.v2',
      translationParams
    );
  } else {
    displayMembershipPeriod = translate(
      'gold.upgrade.price.total.singular.v2',
      translationParams
    );
  }

  return (
    <li className={styles.item}>
      <div className={styles.details}>
        <div className={styles.membershipPrice}>
          <span className={styles.currency}>
            {currency}
          </span>
          <span className={styles.priceDetails} id={`priceDetails_${price}`}>
            {translate(
              'payment.v2.gold.pricePerMonth',
              { 0: `<span>${price}</span>` }
            )}
          </span>
        </div>
        {actions && actions(membership)}
      </div>

      <p className={styles.time} id={`time_${months}M`}>
        {displayMembershipPeriod}
      </p>
    </li>
  );
};

GoldMembershipItem.propTypes = {
  actions: PropTypes.func,
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currency: PropTypes.string,
  membership: PropTypes.object,
  months: PropTypes.number,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

GoldMembershipItem.defaultProps = {
  actions: undefined,
  amount: undefined,
  currency: undefined,
  membership: undefined,
  months: undefined,
  price: undefined,
};

export default GoldMembershipItem;
